export const links = {
  github: 'https://github.com/initMonte',
  linkedin: 'https://www.linkedin.com/in/matias-monteverde',
  mailto: 'mailto:initmonte@gmail.com'
}